import { render, staticRenderFns } from "./selectionIntention.vue?vue&type=template&id=56c84361&scoped=true&"
import script from "./selectionIntention.vue?vue&type=script&lang=js&"
export * from "./selectionIntention.vue?vue&type=script&lang=js&"
import style0 from "./selectionIntention.vue?vue&type=style&index=0&id=56c84361&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c84361",
  null
  
)

export default component.exports